// removed by extract-text-webpack-plugin
module.exports = {"avatarBox":"_3nzptV61i-NClmm_2E_eVa","avatar":"_31LAZTEGeAMDwpZkeC83LX","bullet":"_2fUYRP6P2671oH1QhVhd_p","link":"_2ouMaP_V_8zr_aa0PuzYvO"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/atoms/Avatar/style.css
// module id = 314
// module chunks = 38